/**
 * The route table, as data.
 *
 * Every application route lives BENEATH a locale segment (CON-002), so the paths
 * here are relative to `/:locale`. `PRIMARY_NAVIGATION` is the subset the tab bar
 * shows, in tab order — the areas of FR-11 that carry content today. Learn (FR-09)
 * and Community (FR-10) are out of the tab bar until they have something to show.
 */

export const ROUTE_PATHS = {
    home: '',
    plants: '/plants',
    garden: '/garden',
};

/** `/plants/lavender`, but not `/plants` — one plant, not the shelf. */
const PLANT_DETAIL_PATTERN = /^\/plants\/[^/]+$/u;

/**
 * Which chrome a route wears (SPEC-003 D-7).
 *
 * Three shapes, not a pile of booleans at the call site: the app screens carry
 * both header and tab bar; the landing is a marketing front door with a header
 * and no tab bar; a plant detail page is immersive — artwork to the top edge, its
 * own back button, and one action pinned to the foot, exactly as the approved
 * reference draws it.
 *
 * `brandMark` is the one place a shape differs by more than presence: the landing
 * header is wordmark only. It was introduced so the landing said the lavender
 * ONCE — the hero's divider carried it, so the header gave it up (SPEC-013
 * PR-13.5). The hero's copy has since been removed by request, so the flag now
 * means what it says rather than what it balanced: the front door shows no mark
 * at all. The lavender still opens the app on the boot screen, rides the lockup
 * on every other screen, and is the app icon. Every other screen has no hero to
 * carry it and keeps the mark in the lockup.
 */
export function chromeForRoute(routePath) {
    if (PLANT_DETAIL_PATTERN.test(routePath)) {
        return { header: false, brandMark: false, tabBar: false, immersive: true };
    }

    if (routePath === '/' || routePath === ROUTE_PATHS.home) {
        return { header: true, brandMark: false, tabBar: false, immersive: false };
    }

    return { header: true, brandMark: true, tabBar: true, immersive: false };
}

export const PRIMARY_NAVIGATION = [
    { key: 'home', path: ROUTE_PATHS.home, messageKey: 'nav.home' },
    { key: 'plants', path: ROUTE_PATHS.plants, messageKey: 'nav.plants' },
    { key: 'garden', path: ROUTE_PATHS.garden, messageKey: 'nav.garden' },
];
